// TODO make argument types consistent
import { bestpark } from './base-api';
import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

const getParks = async (key: string, locale: string): Promise<Park[]> => {
  const result = await bestpark.get(`/parks/?lang=${locale}`);
  return result.data;
};

const getPark = async (
  key: string,
  id: string | undefined,
  locale: string,
  data: string = '',
): Promise<Park> => {
  const result = await bestpark.get(
    `/parks/${id}/?lang=${locale}${data ? '&data=' + data : ''}`,
  );
  return result.data;
};

const getAvailableSlots = async (
  key: string,
  id: number | undefined,
  startDate: Date,
  endDate: Date,
  category?: number,
): Promise<Reservation> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  const result = await bestpark.get(
    `/parks/${id}/reservations/available-slots-count?startDate=${start}&endDate=${end}${
      category ? `&category=${category}` : ''
    }`,
  );
  return result.data;
};

const getSlotAvailable = async (
  key: string,
  parkId: number,
  startDate: Date,
  endDate: Date,
): Promise<number[]> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  const result = await bestpark.get(
    `/parks/${parkId}/reservations/available-slots?startDate=${start}&endDate=${end}`,
  );
  return result.data;
};

const getAvailableAncillaries = async (
  key: string,
  id: number | undefined,
  start: Date,
  end: Date,
): Promise<AncillarySlots> => {
  const result = await bestpark.get(
    `/parks/${id}/ancillaries/available-slots?startDate=${start}&endDate=${end}`,
  );

  return result.data;
};

const getParkAncillaries = async (
  key: string,
  id: number | undefined,
  locale: string,
): Promise<ParkAncillary[]> => {
  const result = await bestpark.get(`/parks/${id}/ancillaries?lang=${locale}`);
  return result.data;
};

const getPrices = async (
  key: string,
  id: string | undefined,
  startDate: Date,
  endDate: Date,
  slot?: number,
  category?: number,
): Promise<any> => {
  const start = moment(startDate).format(DATE_FORMAT);
  const end = moment(endDate).format(DATE_FORMAT);
  if (typeof id === 'undefined' || start > end) return null;
  const result = await bestpark.get(
    `/parks/${id}/prices?startDate=${start}&endDate=${end}${
      slot ? `&slot=${slot}` : ''
    }${category ? `&category=${category}` : ''}`,
  );
  return result.data;
};

const getParkSlotInfo = async (
  key: string,
  id: number,
  slot: number,
): Promise<ParkSlotCategory> => {
  const result = await bestpark.get(`/parks/${id}/slot/${slot}`);
  return result.data;
};

export const parksApi = {
  getParks,
  getPark,
  getAvailableSlots,
  getSlotAvailable,
  getAvailableAncillaries,
  getParkAncillaries,
  getPrices,
  getParkSlotInfo,
};
